import ReactDOM from 'react-dom'
import React from 'react'
import App from './app'

const main = document.getElementsByTagName('main')[0]

ReactDOM.render(<App state={ window.state } />, main)
